<template>
  <div>

  	<header>
  		<a href="javascript:void(0)" class="logo" @click="showAbout = !showAbout">
  			<i class="fas fa-bars icon burger"></i>
  			<i class="fas fa-fire fa-lg logoicon"></i>
  			<div class="caption vmid">だれでも急上昇</div>
  		</a>

  		<div class="register">
        <form @submit.prevent="regist">
    			<input type="text" v-model.trim="inputUrl" placeholder="YouTubeの動画URLかIDを入力" spellcheck="false"><select v-model="inputGenre">
    				<option value="nothing">ジャンル</option>
    				<option value="nothing">なし</option>
    				<option value="music">音楽</option>
    				<option value="game">ゲーム</option>
    				<option value="news">ニュース</option>
    				<option value="movie">映画</option>
    				<option value="anime">アニメ</option>
    			</select><button type="submit" :disabled="registLoading">
            登録
            <div v-if="registLoading" class="loader"></div>
          </button>
        </form>
  		</div>

  		<div class="acount">
  			<i class="fas fa-video icon"></i>
  			<i class="fas fa-th icon"></i>
  			<i class="fas fa-comment icon"></i>
  			<i class="fas fa-bell icon"></i>
  			<i class="fas fa-user-circle fa-2x icon face"></i>
  		</div>
  	</header>

    <div class="contents">
      <div class="menu">
        <div class="group">
          <div class="item"><i class="fas fa-home icon"></i><span class="caption">ホーム</span></div>
          <div class="item selected"><i class="fas fa-fire icon"></i><span class="caption">急上昇</span></div>
          <div class="item"><i class="fas fa-caret-square-right icon"></i><span class="caption">登録チャンネル</span></div>
        </div>
        <div class="group">
          <div class="item"><i class="fas fa-folder icon"></i><span class="caption">ライブラリ</span></div>
          <div class="item"><i class="fas fa-history icon"></i><span class="caption">履歴</span></div>
          <div class="item"><i class="fas fa-clock icon"></i><span class="caption">後で見る</span></div>
          <div class="item"><i class="fas fa-thumbs-up icon"></i><span class="caption">高く評価した動画</span></div>
          <div class="item">
            <a href="javascript:void(0)" @click="showAbout = !showAbout">
              <i class="fas fa-question icon"></i><span class="caption">このサイトについて</span>
            </a>
          </div>
          <About v-if="showAbout" class="about"/>
        </div>
        <footer>&copy; daredemo-youtube.com</footer>
      </div>

      <div class="main">

        <About v-if="showAbout" class="mobile-about"/>

        <div v-if="dispGenre == 'nothing'" class="genre">
          <a href="javascript:void(0)" @click="changeDispVideos('music')">
            <div class="btn">
              <div class="image"><i class="fas fa-music fa-2x"></i></div>
              <div class="caption">音楽</div>
            </div>
          </a>
          <a href="javascript:void(0)" @click="changeDispVideos('game')">
            <div class="btn">
              <div class="image"><i class="fas fa-gamepad fa-2x"></i></div>
              <div class="caption">ゲーム</div>
            </div>
          </a>
          <a href="javascript:void(0)" @click="changeDispVideos('news')">
            <div class="btn">
              <div class="image"><i class="fas fa-newspaper fa-2x"></i></div>
              <div class="caption">ニュース</div>
            </div>
          </a>
          <a href="javascript:void(0)" @click="changeDispVideos('movie')">
            <div class="btn">
              <div class="image"><i class="fas fa-film fa-2x"></i></div>
              <div class="caption">映画</div>
            </div>
          </a>
          <a href="javascript:void(0)" @click="changeDispVideos('anime')">
            <div class="btn">
              <div class="image"><i class="fas fa-grin fa-2x"></i></div>
              <div class="caption">アニメ</div>
            </div>
          </a>
        </div>

        <div v-else class="simple-genre">
          <a href="javascript:void(0)" @click="changeDispVideos('nothing')">全て</a>・
          <a href="javascript:void(0)" :class="{selected : dispGenre=='music'}" @click="changeDispVideos('music')">音楽</a>・
          <a href="javascript:void(0)" :class="{selected : dispGenre=='game'}"  @click="changeDispVideos('game')">ゲーム</a>・
          <a href="javascript:void(0)" :class="{selected : dispGenre=='news'}"  @click="changeDispVideos('news')">ニュース</a>・
          <a href="javascript:void(0)" :class="{selected : dispGenre=='movie'}" @click="changeDispVideos('movie')">映画</a>・
          <a href="javascript:void(0)" :class="{selected : dispGenre=='anime'}" @click="changeDispVideos('anime')">アニメ</a>
        </div>

        <List v-if="dispGenre == 'nothing'"    key="1" :genre="dispGenre" :videos="videos"/>
        <List v-if="dispGenre == 'music'"      key="2" :genre="dispGenre" :videos="videos"/>
        <List v-if="dispGenre == 'game'"       key="3" :genre="dispGenre" :videos="videos"/>
        <List v-if="dispGenre == 'news'"       key="4" :genre="dispGenre" :videos="videos"/>
        <List v-if="dispGenre == 'movie'"      key="5" :genre="dispGenre" :videos="videos"/>
        <List v-if="dispGenre == 'anime'"      key="6" :genre="dispGenre" :videos="videos"/>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import firebase from 'firebase/app';
import 'firebase/firestore';
import List from "@/components/List";
import About from "@/components/About";

export default {
  name: 'Top',
  components : {
    List, About
  },
  data () {
    return {
      showAbout : false,
      dispGenre : "nothing",
      videos : {},
      inputUrl : null,
      inputGenre : "nothing",
      registLoading : false,
      resMessage : null
    }
  },
  methods:{

    //--------------
    // 登録処理
    //--------------
    regist:function(){

      // 処理中は無視
      if(this.registLoading) return;

      // 処理開始
      this.registLoading = true;
      this.resMessage = null;

      // functionsに処理を投げる
      axios.post("/registUrl", {
          "videoUrl" : this.inputUrl,
          "genre" : this.inputGenre
      })

      // functions完了時
      .then(response => {
        this.registLoading = false;

        // 正常終了
        if(response.data == "success"){
          this.resMessage = "登録しました！";
          location.reload();

        // エラー表示
        }else if(response.data == "id-error"){
          this.resMessage = "動画のIDが不正です";
        }else if(response.data == "not-found-error"){
          this.resMessage = "動画が見つかりませんでした";
        }else if(response.data == "age-restricted-error"){
          this.resMessage = "年齢制限のある動画は登録できません";
        }else if(response.data == "same-video-error"){
          this.resMessage = "同じ動画は1週間経つまで登録することはできません";
        }else if(response.data == "same-channel-error"){
          this.resMessage = "同じチャンネルの動画は24時間経つまで登録することはできません";
        }else{
          this.resMessage = "サーバーエラー：時間をおいてアクセスしてください";
        }

        alert(this.resMessage);
      })

      // functionsエラー
      .catch(error => {
        this.registLoading = false;
        this.resMessage = "サーバーエラー：時間をおいてアクセスしてください";
        alert(this.resMessage);
      });
    },

    //----------------------
    // 表示ジャンル切り替え
    //----------------------
    changeDispVideos:function(genre){
      this.dispGenre = genre;
    }
  }
}
</script>
<style>
  @import '../assets/style.css';
</style>



// WEBPACK FOOTER //
// src/components/Top.vue